export const LINK_OWNER_UPDATE_ERROR = 'only the owner of this link or admin can update it';
export const PERSONAL_LINK_CREATE_ERROR = 'cannot create personal links';
export const FORBIDDEN_ERROR_CODE = 403;
export const VCE_ACCOUNT_ID_ERROR = 'Account ID is required for VCE app';
export const CREATE_TEAM_LINK_ERROR = 'cannot create team links';